import { useRef, useState } from 'react';

import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useSWRMutation from 'swr/mutation';

import { FormDialog } from '~components';
import { NfcTag, SkcNfcTagForm, SkcKeysService } from '~features/nfc';
import { useSnackbar } from '~hooks';

import SkcNfcTagsDataGrid from '../components/dataGrids/skcNfcTagsDatagrid';

interface UserAction {
	type: 'edit';
	id: string;
	value: object;
}

const service = new SkcKeysService();

const SkcNfcTagsOverviewContainer = () => {
	const { t } = useTranslation();
	const { enqueueSuccessSnackbar, enqueueAxiosErrorSnackbar } = useSnackbar();
	const [userAction, setUserAction] = useState<UserAction | null>(null);
	const dataGridRef = useRef<{ mutate: () => void }>(null);

	const { trigger: triggerEdit, isMutating: isEditMutating } = useSWRMutation(
		userAction?.id ? [service.basePath, userAction.id] : null,
		([_, id], { arg }: { arg: NfcTag }) => service.putKey(id, arg),
		{
			onSuccess: () => {
				enqueueSuccessSnackbar(`${t('ui.success.message.updated')} ${t('nfcTag')}`);
				setUserAction(null);
				dataGridRef.current?.mutate();
			},
			onError: (error) => enqueueAxiosErrorSnackbar(error),
		}
	);

	return (
		<Stack
			sx={{
				height: 1,
			}}
		>
			<SkcNfcTagsDataGrid
				ref={dataGridRef}
				onEdit={(value) => setUserAction({ type: 'edit', id: value.id, value: value })}
			/>
			<FormDialog
				title={t('editResource', {
					resource: t('accessTag'),
					// formatParams: { ignore: true }
				})}
				open={userAction?.type === 'edit' || userAction?.type === 'create'}
				loading={isEditMutating}
				onClose={() => setUserAction(null)}
				maxWidth='xs'
				fullWidth
			>
				<SkcNfcTagForm id={userAction?.id} onSubmit={async (data) => await triggerEdit(data)} />
			</FormDialog>
		</Stack>
	);
};

export default SkcNfcTagsOverviewContainer;
